import type { FC } from "react";
import { Box, Button, Stack } from "@mui/material";
import type { StackProps } from "@mui/material";

interface SwitchButtonProps {
  value: any;
  items: { text: string; value: any; hasDot?: boolean }[];
  onChange: (newValue: any) => void;
  containerProps?: StackProps;
}

export const SwitchButton: FC<SwitchButtonProps> = ({
  value,
  items,
  containerProps,
  onChange,
}) => {
  return (
    <Stack
      direction={"row"}
      bgcolor={"#29292D"}
      p={0.8}
      borderRadius={"10px"}
      {...containerProps}
    >
      {items.map((item) => (
        <Button
          variant={item.value === value ? "contained" : "text"}
          sx={[
            item.value !== value && { color: "rgba(255,255,255,0.7)" },
            { flex: 1, px: 1, py: 0.5 },
          ]}
          onClick={() => onChange(item.value)}
          key={item.value}
        >
          {item.text}
          {item.hasDot && (
            <Box
              height={"4px"}
              width={"4px"}
              bgcolor={"error.main"}
              borderRadius={"4px"}
              mx={0.5}
            />
          )}
        </Button>
      ))}
    </Stack>
  );
};
